export default __webpack_public_path__ + "static/media/section1.387160d3.jpg";